enum TriggerDriverIdentificationRecurrence {
  EACH_30_MINUTES = 'EACH_30_MINUTES',
  EACH_1_HOUR = 'EACH_1_HOUR',
  EACH_2_HOURS = 'EACH_2_HOURS',
  ONCE_A_DAY = 'ONCE_A_DAY',
}

export { TriggerDriverIdentificationRecurrence };
